import { Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { getAssignedProjects } from '../../../modules/project';
import QUERY_KEYS from '../../../query/queryKeys';
import { projectTableHead } from '../../../static-data/projects';
import Loader from '../../elements/Loader';
import TableComponent from '../../../ui/data/table/TableComponent';
import FavouriteProjectToggle from './FavouriteProjectToggle';

const AssignedProjects = () => {
  const [order, setOrder] = useState('desc');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey: QUERY_KEYS.project.assignedProjects(page, perPage),
    queryFn: () => getAssignedProjects({ page, perPage }),
  });

  const projects = data?.projects || [];
  const totalCount = data?.total || 0;

  const handlePageSizeChange = (e) => {
    setPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  return (
    <>
      <Row>
        <Col>
          <Typography variant="h4" className="mb-3">
            Your Projects
          </Typography>
        </Col>
      </Row>

      <Row>
        <Col>
          {isLoading ? (
            <Loader />
          ) : (
            <TableComponent
              data={projects}
              headerTabs={projectTableHead}
              order={order}
              setOrder={setOrder}
              defaultSort="created_at"
              isLoading={isFetching}
              striped
              page={page}
              setPage={setPage}
              perPage={perPage}
              setPerPage={handlePageSizeChange}
              totalCount={totalCount}
              showPages
              showCount
              showRowCount
              handlePageChange={setPage}
              action={(row) => (
                <>
                  <FavouriteProjectToggle
                    projectId={row.id}
                    isMarkedFavourite={row.is_favourite}
                    refetch={refetch}
                  />
                </>
              )}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default AssignedProjects;
